'use strict';

var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var react = require('react');

var useControllableState = function useControllableState(_ref) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$onValueChange = _ref.onValueChange,
      onValueChange = _ref$onValueChange === void 0 ? function () {} : _ref$onValueChange;

  var _react$useState = react.useState(defaultValue),
      _react$useState2 = _slicedToArray(_react$useState, 2),
      controlledValue = _react$useState2[0],
      setControlledValue = _react$useState2[1];

  var _react$useState3 = react.useState(defaultValue),
      _react$useState4 = _slicedToArray(_react$useState3, 2),
      previousDefaultValue = _react$useState4[0],
      setPreviousDefaultValue = _react$useState4[1];

  if (defaultValue !== previousDefaultValue) {
    setPreviousDefaultValue(defaultValue);
    console.warn("useControllableState: `defaultValue` is changing after component is mounted. Changing `defaultValue` will not change the initial value of the component.");
  }

  var handleControlledChange = function handleControlledChange(value_) {
    setControlledValue(value_);
    onValueChange === null || onValueChange === void 0 || onValueChange(value_);
  };

  if (value !== void 0) {
    return [value, onValueChange];
  }

  return [controlledValue, handleControlledChange];
};

var useError = function useError() {
  var _react$useState5 = react.useState(),
      _react$useState6 = _slicedToArray(_react$useState5, 2),
      error = _react$useState6[0],
      setError = _react$useState6[1];

  var _react$useState7 = react.useState(),
      _react$useState8 = _slicedToArray(_react$useState7, 2),
      previousError = _react$useState8[0],
      setPreviousError = _react$useState8[1];

  if (error && error !== previousError) {
    setPreviousError(error);
    throw error;
  }

  var dispatchError = react.useCallback(function (error2) {
    setError(error2);
  }, []);
  return dispatchError;
};

exports.useControllableState = useControllableState;
exports.useError = useError;